<template>
  <div>
    <a
      :href="appleAppStoreUrl"
      :aria-label="$t('mobile-app.app-store')"
      target="_blank"
      rel="noopener noreferrer"
      class="block"
      :class="buttonSize"
      @click="trackEvent('app_store')"
    >
      <img
        :src="appStoreLogoPath"
        :alt="$t('mobile-app.app-store')"
      />
    </a>
    <a
      :href="googlePlayUrl"
      :aria-label="$t('mobile-app.google-play')"
      target="_blank"
      rel="noopener noreferrer"
      class="block"
      :class="buttonSize"
      @click="trackEvent('play_store')"
    >
      <img
        :src="googlePlayLogoPath"
        :alt="$t('mobile-app.google-play')"
      />
    </a>
  </div>
</template>

<script>
import { getCookie } from '@/helpers/cookies';
import { getAssetUrl } from '@/helpers/url';
import { i18n } from '@/i18n';

export default {
  name: 'VetsterMobileAppButtons',

  props: {
    appleAppStoreUrl: {
      type: String,
      required: true,
    },
    buttonSize: {
      type: String,
      default: '',
    },
    gaChild: {
      type: String,
      default: '',
    },
    gaParent: {
      type: String,
      default: '',
    },
    gaType: {
      type: String,
      default: '',
    },
    googlePlayUrl: {
      type: String,
      required: true,
    },
  },

  computed: {
    appStoreLogoPath() {
      return getAssetUrl(`images/${this.isFrench ? 'fr/' : ''}app-store.svg`);
    },
    googlePlayLogoPath() {
      return getAssetUrl(`images/${this.isFrench ? 'fr/' : ''}google-play.svg`);
    },
    isFrench() {
      return i18n.locale === 'fr-CA';
    },
  },

  methods: {
    trackEvent(store) {
      this.$analytics.track({
        eventName: `${store}_cta_click`,
        uat_id: getCookie('v-uatid'),
        child: this.gaChild,
        parent: this.gaParent,
        type: this.gaType,
      });

      return true;
    },
  },
};
</script>
